import './App.css';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import ProjectDetail from './components/ProjectDetail';

const getStatusClass = (status) => {
  switch (status.toLowerCase()) {
    case 'ongoing':
      return 'status-ongoing';
    case 'completed':
      return 'status-completed';
    case 'pending':
      return 'status-pending';
    default:
      return 'status-ongoing';
  }
};

const projects = [
  {
    fileNumber: '01',
    title: 'APP ERRATA',
    status: 'Ongoing',
    image: '/assets/consulting.png',
    date: '2021-SEP-30',
    path: '/project/app-errata',
    description: 'A collection of development projects where I focus on building versatile, scalable solutions that integrate various technologies to enhance efficiency and user experience.'
  },
  {
    fileNumber: '02',
    title: 'ARS MATERIA',
    status: 'Completed',
    image: '/assets/arsmateria.png',
    date: '2024-FEB-12',
    path: '/project/ars-materia',
    description: 'ARS Materia is a delightful project focused on creating handcrafted wood pottery tools. Using precision from laser and CNC machining, each piece is finished with a unique handcrafted touch, blending modern technology with traditional craftsmanship.'
  },
  {
    fileNumber: '03',
    title: 'uID Cafe',
    status: 'Ongoing',
    image: '/assets/uid.png',
    date: '2025-JAN-23',
    path: '/project/uid-cafe',
    description: 'uID Cafe is a project centered around creating a unique customer journey and performance tracking system through customizable dynamic links, providing organizations with real-time insights into marketing segment ROI and customer behaviors.'
  },
  {
    fileNumber: '04',
    title: 'OMEN TACTICS',
    status: 'Pending',
    image: '/assets/omen.png',
    date: '2023-OCT-30',
    path: '/project/omen-tactics',
    description: 'Omen Tactics is an Unreal Engine 5 endeavor aimed at crafting a distinct persistent world. It revolves around turn-based, top-down tactical combat, offering players a deeply immersive gaming experience within a dynamically evolving environment.'
  }
];

const ProjectCard = ({ project }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(project.path);
  };

  return (
    <div className="project-card" onClick={handleClick}>
      <div className="file-number">FILE {project.fileNumber}</div>
      <h2 className="project-title">{project.title}</h2>
      <div className={`project-status ${getStatusClass(project.status)}`}>
        {project.status}
      </div>
      <img src={project.image} alt={project.title} className="project-image" />
      <div className="project-date">{project.date}</div>
    </div>
  );
};

const HomePage = () => (
  <main className="main-content">
    <div className="projects-grid">
      {projects.map((project) => (
        <ProjectCard key={project.fileNumber} project={project} />
      ))}
    </div>
  </main>
);

const Navigation = () => (
  <nav className="navbar">
    <div className="navbar-logo">
      <img style={{height: '35pt'}} src="/assets/ae.svg" alt="AE Logo" />
      <h1 style={{fontWeight: '300', marginLeft: '12px', fontSize: '48pt'}}>APP ERRATA</h1>
    </div>
  </nav>
);

function App() {
  return (
    <Router>
      <div className="App">
        <Navigation />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/project/:projectId" element={<ProjectDetail projects={projects} />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
